<template>
  <section class="">
    <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 p-col-12">
    <DataTable
      :value="billSundaryLists"
      :paginator="true"
      :rows="10" :filters="filters"
      class="p-datatable-responsive p-datatable-gridlines"
      data-key="id"
    >
      <Column header="S.N">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" field="expensesName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['expensesName']"/>
        </template>
      </Column>
      <Column header="Apply Costing" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.applyCostPerUnit ? 'Yes' : 'No' }}
        </template>
      </Column>
      <Column header="Apply Vat">
        <template #body="slotProps">
          {{ slotProps.data.applyVat ? 'Yes' : 'No' }}
        </template>
      </Column>
      <Column header="Debit Account" field="debitAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['debitAccountName']"/>
        </template>
      </Column>

      <Column header="Credit Account" field="creditAccountName" filterMatchMode="contains" :sortable="true">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['creditAccountName']"/>
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <Button type="button" class="p-button-raised p-button-success"
                  @click="editBillSundary(slotProps.data)" icon="pi pi-pencil"/>
          <Button class="p-button-raised p-button-danger" v-if="!slotProps.data.systemOnly"
                  @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <Button class="p-button-raised p-button-danger"
                  v-else @click="openDialog(slotProps.data.id)" icon="pi pi-trash" disabled/>
        </template>
      </Column>
    </DataTable>
      </div>
      </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deletePurchaseSundary"/>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'billSundaryList',
  data() {
    return {
      dialogShow: false,
      accountId: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    billSundaryLists() {
      return this.$store.state.billSundary.billSundaryLists
    }
  },
  mounted() {
    this.billSundaryList()
  },
  methods: {
    async billSundaryList() {
      await this.$store.dispatch('loadPurchaseBillSundry')
    },
    async deletePurchaseSundary(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty.',
          messageType: 'error'
        }
        this.dialogShow = true
        this.$emit('delete-message', message)
        return
      }
      let deleteRe = {
        inventoryExpensesId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseSundary', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        this.show = true
        this.setTimeInterval()
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editBillSundary(data) {
      this.$emit('edit-account', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
    }
  }
}
</script>

<style>
.p-datatable table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  column-gap: inherit;
}
</style>



// WEBPACK FOOTER //
// purchaseExtraExpensesList.vue?0ed88bd7